import { render, staticRenderFns } from "./PurchaseDetails.vue?vue&type=template&id=9c89c118"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDetails.vue?vue&type=style&index=0&id=9c89c118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports